
import JsonView from '@uiw/react-json-view';
import { lightTheme } from '@uiw/react-json-view/light';

type JsonViewerProps = {
  value: string | Record<string, unknown> | unknown[];
};

export function JsonPreview({ value }: JsonViewerProps) {
  const parsedValue = typeof value === "string" ? JSON.parse(value) : value;

  return (
    <div className="rounded-lg border border-gray-200 bg-white px-3 py-2">
      <JsonView
        value={parsedValue}
        displayDataTypes={false}
        displayObjectSize={false}
        enableClipboard={true}
        collapsed={false}
        style={{
          ...lightTheme,
          'fontSize': '14px',
          'backgroundColor': 'transparent',
          'color': '#111827',       // main text (gray-900)
        }}
      />
    </div>
  );
}
